import "./pages.css";

export const Private2 = () => {
    return(
        <h1 className="content">
            PRIVATE PAGE 2
        </h1>
    );
}